import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HotelAPI from '../serviceAPI/HotelAPI';

const initialState = {
  hotelList: [],
  hotelRequestList: [],
  hotelScheduledList: [],
  isLoading: false,
  prevThumbnailDetails: null,
  prevThumbnailId: '',
  prevHotelImageDetails: null,
  prevHotelIds: null,
  errorCode: null,
};

export const getAllHotelList = createAsyncThunk(
  'getAllHotelList',
  async (id, { rejectWithValue }) => {
    try {
      const res = await HotelAPI.GetAllHotels(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const getAllHotelRequestList = createAsyncThunk(
  'getAllHotelRequestList',
  async (id, { rejectWithValue }) => {
    try {
      const res = await HotelAPI.GetAllHotelRequests(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const getAllHotelScheduledList = createAsyncThunk(
  'getAllHotelScheduledList',
  async (id, { rejectWithValue }) => {
    try {
      const res = await HotelAPI.GetAllHotelScheduled(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const createNewHotel = createAsyncThunk(
  'createNewHotel',
  async ({ id, newData }, { rejectWithValue }) => {
    try {
      const res = await HotelAPI.CreateNewHotel(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const createNewHotelSchedule = createAsyncThunk(
  'createNewHotelSchedule',
  async ({ id, newData }, { rejectWithValue }) => {
    try {
      const res = await HotelAPI.ScheduleHotelBooking(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const updateHotel = createAsyncThunk(
  'updateHotel',
  async ({ newData, id }, { rejectWithValue }) => {
    try {
      const res = await HotelAPI.UpdateHotel(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const deleteHotel = createAsyncThunk(
  'deleteHotel',
  async (id, { rejectWithValue }) => {
    try {
      const res = await HotelAPI.DeleteHotel(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);
export const updateHotelOrder = createAsyncThunk(
  'refuel/updateHotelOrder',
  async ({ officeId, orderedArray }, { rejectWithValue }) => {
    try {
      // orderedArray: [{ _id, name, order }, ...]
      const res = await HotelAPI.UpdateHotelOrder(officeId, orderedArray);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.status || 'Network Error');
    }
  }
);
const HotelSlice = createSlice({
  name: 'hotel',
  initialState,
  reducers: {
    setPrevThumbnailDetails: (state, action) => {
      state.prevThumbnailDetails = action.payload;
    },
    setPreThumbnailId: (state, action) => {
      state.prevThumbnailId = action.payload;
    },
    setPrevHotelImageDetails: (state, action) => {
      state.prevHotelImageDetails = action.payload;
    },
    setPrevHotelIds: (state, action) => {
      state.prevHotelIds = action.payload;
    },
    resetErrorAlert: (state, action) => {
      state.errorCode = null;
    },
  },
 extraReducers: (builder) => {
  builder
    // getAllHotelList
    .addCase(getAllHotelList.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(getAllHotelList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.hotelList = [...action.payload];
    })
    .addCase(getAllHotelList.rejected, (state, action) => {
      state.isLoading = false;
      state.errorCode = action.payload;
    })

    // getAllHotelRequestList
    .addCase(getAllHotelRequestList.fulfilled, (state, action) => {
      const requestResult = action.payload.filter(
        (req) => req.isBooked === false
      );
      state.hotelRequestList = [...requestResult];
    })
    .addCase(getAllHotelRequestList.rejected, (state, action) => {
      state.errorCode = action.payload;
    })

    // getAllHotelScheduledList
    .addCase(getAllHotelScheduledList.fulfilled, (state, action) => {
      state.hotelScheduledList = [...action.payload];
    })
    .addCase(getAllHotelScheduledList.rejected, (state, action) => {
      state.errorCode = action.payload;
    })

    // createNewHotel
    .addCase(createNewHotel.fulfilled, (state, action) => {
      state.hotelList.push(action.payload);
    })
    .addCase(createNewHotel.rejected, (state, action) => {
      state.errorCode = action.payload;
    })

    // createNewHotelSchedule
    .addCase(createNewHotelSchedule.fulfilled, (state, action) => {
      state.hotelScheduledList.push(action.payload);
      const requestResult = state.hotelRequestList.filter(
        (req) => req._id !== action.payload.requestedId
      );
      state.hotelRequestList = [...requestResult];
    })
    .addCase(createNewHotelSchedule.rejected, (state, action) => {
      state.errorCode = action.payload;
    })

    // updateHotel
    .addCase(updateHotel.fulfilled, (state, action) => {
      state.hotelList = state.hotelList.map((hotel) =>
        hotel._id === action.payload._id ? action.payload : hotel
      );
    })
    .addCase(updateHotel.rejected, (state, action) => {
      state.errorCode = action.payload;
    })

    // deleteHotel
    .addCase(deleteHotel.fulfilled, (state, action) => {
      const id = action.payload._id;
      const index = state.hotelList.map((item) => item._id).indexOf(id);
      state.hotelList.splice(index, 1);
    })
    .addCase(deleteHotel.rejected, (state, action) => {
      state.errorCode = action.payload;
    })

    // updateHotelOrder
    .addCase(updateHotelOrder.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(updateHotelOrder.fulfilled, (state) => {
      state.isLoading = false;
    })
    .addCase(updateHotelOrder.rejected, (state, action) => {
      state.isLoading = false;
      state.errorCode = action.payload;
    });
},
});

export const {
  setPrevThumbnailDetails,
  setPreThumbnailId,
  setPrevHotelImageDetails,
  setPrevHotelIds,
  resetErrorAlert,
} = HotelSlice.actions;
export default HotelSlice.reducer;
